import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import NotificationsIcon from "@mui/icons-material/Notifications";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import logo from "assets/img/slide/logo_white.png";
import UserContext from "components/contexts/UserContext";
import ProfileMenu from "components/ProfileMenu";
import React, { useContext, useEffect, useRef, useState } from "react";

export default function Header() {
  const { userLink } = useContext(UserContext);

  const [openMenu, setOpenMenu] = useState(false);
  const prevOpen = useRef(openMenu);
  const anchorRef = useRef(null);

  const handleToggleMenu = () => {
    setOpenMenu(!openMenu);
  };

  useEffect(() => {
    if (prevOpen.current === true && openMenu === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = openMenu;
  }, [openMenu]);

  return (
    <div>
      <AppBar
        position="fixed"
        sx={(theme) => ({
          zIndex: theme.zIndex.drawer + 1,
          transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
        })}
      >
        <Toolbar
          sx={(theme) => ({
            pr: 3,
            [theme.breakpoints.down("sm")]: { textAlign: "center" },
          })}
        >
          <Box sx={{ flexGrow: 1 }}>
            <Box component="img" src={logo} alt="" sx={{ maxWidth: 150 }} />
          </Box>
          <Box sx={{ display: { xs: "none", sm: "block" } }}>
            <Tooltip title="Updates">
              <Box component="span" className="beamerTrigger" sx={{ pr: 1 }}>
                <NotificationsIcon />
              </Box>
            </Tooltip>
          </Box>
          <Tooltip title={userLink ? userLink.email : ""}>
            <Box sx={{ display: { xs: "none", sm: "block" }, ml: 1 }}>
              {userLink && (
                <Typography>
                  {userLink.first_name + " " + userLink.last_name}
                </Typography>
              )}
            </Box>
          </Tooltip>
          <IconButton
            ref={anchorRef}
            aria-controls={openMenu ? "menu-list-grow" : undefined}
            aria-haspopup="true"
            onClick={handleToggleMenu}
            color="inherit"
            size="large"
          >
            <AccountCircleIcon fontSize="large" />
          </IconButton>
          <ProfileMenu
            openMenu={openMenu}
            setOpenMenu={setOpenMenu}
            anchorRef={anchorRef}
          />
        </Toolbar>
      </AppBar>
    </div>
  );
}
